// Task 11b — US phone number helpers.
//
// Storage contract: raw 10 digits as a string (no formatting).
// Display contract: ``(XXX) XXX-XXXX`` formatted by ``formatPhoneForDisplay``.
//
// NANP rules enforced:
//   * Exactly 10 digits
//   * Area code first digit must be 2-9
//   * Exchange (positions 4-6) first digit must be 2-9
//   * Reject ``0000000000``
//
// International / +1-prefixed inputs are tolerated on extraction: a leading
// "1" is stripped when the digit count is 11. Anything else is left raw and
// will fail validation.

export function extractDigits(value) {
    const s = String(value ?? "");
    const d = s.replace(/\D/g, "");
    // Tolerate a US country-code prefix: "1XXXXXXXXXX" → "XXXXXXXXXX".
    if (d.length === 11 && d.startsWith("1")) return d.slice(1);
    return d;
}

export function isValidUSPhone(value) {
    const d = extractDigits(value);
    if (d.length !== 10) return false;
    if (d === "0000000000") return false;
    const area = d.charAt(0);
    const exch = d.charAt(3);
    // NANP: area + exchange must each start with 2-9.
    if (area < "2" || area > "9") return false;
    if (exch < "2" || exch > "9") return false;
    return true;
}

export function formatPhoneForDisplay(value) {
    const d = extractDigits(value);
    if (d.length !== 10) return "";
    return `(${d.slice(0, 3)}) ${d.slice(3, 6)}-${d.slice(6)}`;
}

// Live-format helper for in-progress typing.
//   "4"      → "4"
//   "41"     → "41"
//   "415"    → "415"
//   "4155"   → "(415) 5"
//   "41555"  → "(415) 55"
//   "415555" → "(415) 555"
//   "4155551"→ "(415) 555-1"
//   "4155551234" → "(415) 555-1234"
export function formatPhoneWhileTyping(value) {
    const d = extractDigits(value).slice(0, 10);
    if (d.length === 0) return "";
    if (d.length < 4) return d;
    if (d.length < 7) return `(${d.slice(0, 3)}) ${d.slice(3)}`;
    return `(${d.slice(0, 3)}) ${d.slice(3, 6)}-${d.slice(6)}`;
}
